exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".AssetAllocationFunds__sliderHolder{margin:0 25px}.AssetAllocationFunds__sliderHolder .slick-next::before{content:none}.AssetAllocationFunds__sliderHolder .slick-prev::before{content:none}.AssetAllocationFunds__donut{background-color:#dddddd29;border:1px solid #aaa;height:500px}@media only screen and (min-width: 1220px){.AssetAllocationFunds__donut{height:570px}}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/dist/cjs.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/pages/Create_portfolio_by_Advisor/asset_allocation_funds/AssetAllocationFunds.style.scss
// module id = 1630
// module chunks = 0